module.exports = __webpack_public_path__ + "img/alehouse-logo.156fe6c9.jpg";